import * as actionType from "../constants";

const initialData = {
  attributes: [],
  loading: false,
  rows: {},
  child_board: [],
  status: "",
  message: "",
  title: "",
  board: false,
  statusChange: false,
  history: [],
  history_attributes: {},
  bord_details: [],
  monitor: [],
  isMonitorAdded: true,
  isAdding: false,
  imageUpload: {},
  allAttachImage_add: {},
  allAttachImage_edit: {},
  isImageUpload: false,
  imageUploadAddListing: {},
  allAttachImage_add_listing: {},
  attachment_er: {},
  child_board_images_edit: {},
  filter: {},
  filterpopup: { board: false, message: "", code: "", title: "", bg: "" },
  toggleMenu: true,
  todoData: [],
  users: {},
};

export const boardAttributeForm = (state = initialData, action) => {
  switch (action.type) {
    case actionType.USER_API_CALL:
      return { ...state, users: action.payload };
    case actionType.LOADING_FORM_ATTRIBUTE:
      return { ...state, loading: true };
    case actionType.BOARD_ATTRIBUTE_LISTING:
      return {
        ...state,
        attributes: action.payload.attribute || [],
        loading: false,
        status: action.payload.status,
        board: false,
      };
    case actionType.BOARD_FALSE_DEFAULT:
      return {
        ...state,
        board: false,
      };
    case actionType.UPDATE_SINGLE_ROW:
      return {
        ...state,
        rows: action.payload.rows,
        message: action.payload.message,
        title: action.payload.title,
        board: true,
      };
    case actionType.UPDATE_SINGLE_BOARD_FALSE:
      return {
        ...state,
        board: false,
      };
    case actionType.SHOW_STATUS_CHANGE:
      return {
        ...state,
        board: true,
        statusChange: true,
        status: 200,
        title: "success",
        message: "Status updated successfully!",
      };
    case actionType.HIDE_STATUS_CHANGE:
      return {
        ...state,
        board: false,
        code: "",
        status: "",
        title: "",
        message: "",
      };
    case actionType.CLEARING_ALL_COLUMNS:
      return { ...state, rows: {}, status: 0 };
    case actionType.BOARD_ATTRIBUTE_TATTLE_DETAILS_NULL:
      return {
        ...state,
        status: action.payload.status,
      };
    case actionType.UPDATE_ROW_STATUS:
      const rowdatas = { ...state.rows };
      const boarddetails = { ...state.bord_details };
      boarddetails.status[0].options = action.payload.newStatus;
      rowdatas.status = action.payload.id;
      return { ...state, rows: rowdatas, bord_details: boarddetails };
    case actionType.BOARD_ATTRIBUTE_TATTLE_DETAILS:
      let monitor;
      if (action.payload.rows) {
        monitor = [...new Set(action.payload?.rows?.monitoring)] || [];
      }

      return {
        ...state,
        bord_details: action.payload.bord_details,
        rows: action.payload?.rows || {},
        monitor: monitor || [],
        board: false,
        status: action.payload.status,
        users: action.payload.users,
      };
    case actionType.GET_CHILD_BOARD:
      return {
        ...state,
        child_board: action.payload,
      };
    case actionType.REPLY_TO_CUSTOMER:
      const repldata = { ...state.rows };
      repldata["replied"] = "yes";
      return {
        ...state,
        rows: repldata,
      };
    case actionType.BOARD_ATTRIBUTE_TATTLE_DETAILS_AFTER_UPLOAD:
      const rowsss = { ...state.rows };
      rowsss["attachment"] = {
        ...state.rows.attachment,
        ...action.payload.attachments,
      };
      return {
        ...state,
        rows: rowsss || {},
      };
    case actionType.REMOVE_ATTACHMENT:
      const newrows = { ...state.rows };
      const attach = delete newrows.attachment[action.idd];

      newrows.attachment = { ...newrows.attachment, ...attach };

      return { ...state, rows: newrows };
    case actionType.SET_NEW_STATUS_WORKFLOW:
      const board_detnew = [...state.bord_details?.status];
      board_detnew[0]["options"] = action.payload;

      return {
        ...state,
        bord_details: { ...state.bord_details, board_detnew },
        status: 200,
      };
    case actionType.GET_ALL_BOARD_HISTORY:
      return {
        ...state,
        history: [...action.payload.history],
        history_attributes: action.payload.hisAttributes,
      };
    case actionType.RELATE_VICE_VERSA:
      return {
        ...state,
        rows: { ...state.rows, ...action.payload },
      };
    case actionType.ENABLE_MONITORING:
      return {
        ...state,
        isMonitorAdded: true,
      };
    case actionType.MONITOR_ADDING:
      return {
        ...state,
        isAdding: true,
      };
    case actionType.ADDING_MONITOR:
      return {
        ...state,
        monitor: [...state.monitor, ...action.payload?.attribute_value],
        isMonitorAdded: false,
        isAdding: false,
      };
    case actionType.ASSIGN_TO_UPDATE:
      const rowss = { ...state.rows };
      rowss["assign_to"] = action.payload.assign;
      return {
        ...state,
        rows: rowss,
        board: action.payload.board,
        title: action.payload.title,
        message: action.payload.message,
      };
    case actionType.REMOVE_MONITOR:
      const monitors = state.monitor.filter(
        (itt) => !action.payload.includes(itt)
      );
      return { ...state, monitor: monitors };
    case actionType.IMAGE_UPLOAD_START:
      return { ...state, isImageUpload: true };
    case actionType.IMAGE_UPLOAD_PROGRESS:
      return {
        ...state,
        imageUpload: {
          ...state.imageUpload,
          [action.payload.id]: {
            ...state.imageUpload[action.payload.id],
            [action.payload.image_name]: {
              file_name: action.payload.image_name,
              progress: action.payload.progress,
              is_complete: action.payload.is_complete,
              size: action.payload.size,
            },
          },
        },
      };
    case actionType.IMAGE_UPLOAD_PROGRESS_COMPLETE:
      for (let ii in state?.imageUpload?.[action?.payload?.id]) {
        if (state?.imageUpload?.[action?.payload?.id][ii]?.progress === 100) {
          delete state?.imageUpload?.[action?.payload?.id][ii];
        }
      }
      return {
        ...state,
        isImageUpload: false,
        imageUpload: {
          ...state.imageUpload,
          [action.payload.id]: {
            ...state.imageUpload[action.payload.id],
            [action.payload.image_name]: {
              file_name: action.payload.image_name,
              progress: action.payload.progress,
              is_complete: action.payload.is_complete,
              size: action.payload.size,
            },
          },
        },
      };
    case actionType.IMAGE_UPLOAD_ERROR:
      return {
        ...state,
        imageUpload: {
          ...state.imageUpload,
          [action.payload.id]: {
            ...state.imageUpload[action.payload.id],
            [action.payload.image_name]: {
              file_name: action.payload.image_name,
              is_error: action.payload.is_error,
              error: action.payload.error,
              size: action.payload.size,
              is_complete: action.payload.is_complete,
              progress: action.payload.progress,
            },
          },
        },
      };
    case actionType.IMAGE_UPLOAD_DONE:
      return {
        ...state,
        allAttachImage_add: { ...state.allAttachImage_add, ...action.payload },
        isImageUpload: false,
      };
    case actionType.IMAGE_UPLOAD_DONE_EDIT:
      return {
        ...state,
        allAttachImage_edit: {
          ...state.allAttachImage_edit,
          ...action.payload,
        },
        isImageUpload: false,
      };
    case actionType.IMAGE_UPLOAD_DONE_ADD_LISTING:
      for (let ii in state?.imageUploadAddListing) {
        if (state?.imageUploadAddListing[ii]?.progress === 100) {
          delete state?.imageUploadAddListing?.[ii];
        }
      }
      return {
        ...state,
        allAttachImage_add_listing: {
          ...state.allAttachImage_add_listing,
          ...action.payload,
        },
        isImageUpload: false,
      };
    case actionType.IMAGE_UPLOAD_DONE_ADD_LISTING_CHILD_BOARD:
      console.log(action, "new check atta");
      return {
        ...state,
        child_board_images_edit: { ...action.payload.child_board_er },
      };
    case actionType.CHILD_BOARD_IMAGE_REMOVE:
      let childboardimage = { ...state.child_board_images_edit };

      childboardimage = {
        ...delete childboardimage[action.payload.id],
        ...childboardimage,
      };

      return {
        ...state,
        child_board_images_edit: childboardimage,
      };
    case actionType.CLEAR_ALL_IMAGE:
      return {
        ...state,
        allAttachImage_add: null,
        allAttachImage_edit: null,
        allAttachImage_add_listing: null,
      };
    case actionType.IMAGE_UPLOAD_PROGRESS_COMPLETE_ADD_LISTING:
      console.log(state.imageUploadAddListing, 654897654132);
      for (let ii in state?.imageUploadAddListing) {
        if (state?.imageUploadAddListing[ii]?.progress === 100) {
          delete state?.imageUploadAddListing?.[ii];
        }
      }
      return {
        ...state,
        imageUploadAddListing: {
          ...state.imageUploadAddListing,
          [action.payload.image_name]: {
            file_name: action.payload.image_name,
            progress: action.payload.progress,
            is_complete: action.payload.is_complete,
            size: action.payload.size,
          },
        },
      };
    case actionType.IMAGE_UPLOAD_PROGRESS_ADD_LISTING:
      return {
        ...state,
        imageUploadAddListing: {
          ...state.imageUploadAddListing,
          [action.payload.image_name]: {
            file_name: action.payload.image_name,
            progress: action.payload.progress,
            is_complete: action.payload.is_complete,
            size: action.payload.size,
          },
        },
      };
    case actionType.IMAGE_UPLOAD_ERROR_ADD_LISTING:
      return {
        ...state,
        imageUploadAddListing: {
          ...state.imageUploadAddListing,
          [action.payload.image_name]: {
            file_name: action.payload.image_name,
            is_error: action.payload.is_error,
            error: action.payload.error,
            size: action.payload.size,
            is_complete: action.payload.is_complete,
            progress: action.payload.progress,
          },
        },
      };
    case actionType.GET_BOARD_FILTER_ACTION:
      return {
        ...state,
        filter: action.data,
        filterpopup: {
          ...state.filterpopup,
          board: false,
        },
      };
    case actionType.CREATE_CUSTOM_FILTER:
      const allFilters = { ...state.filter };
      let newfilter = [...allFilters.filter.user_filter];
      newfilter.unshift(action.payload.newFilter);
      allFilters["filter"]["user_filter"] = newfilter;
      return {
        ...state,
        filter: allFilters,
        filterpopup: {
          ...state.filterpopup,
          board: true,
          message: action.payload.newFilter.message,
          code: 200,
          title: "success",
          bg: "primary",
        },
      };
    case actionType.CREATE_CUSTOM_FILTER_ERROR:
      return {
        ...state,
        filterpopup: {
          ...state.filterpopup,
          board: true,
          message: action.payload.message,
          code: action.payload.code,
          title: "ERROR",
          bg: "danger",
        },
      };
    case actionType.DELETE_FILTER:
      const delallFilters = { ...state.filter };
      let delnewfilter = [...delallFilters.filter.user_filter];
      let newdelfilter = delnewfilter.filter(
        (item) => item.filter_id !== action.payload.filter_id
      );
      delallFilters["filter"]["user_filter"] = newdelfilter;
      return {
        ...state,
        filter: delallFilters,
        filterpopup: {
          ...state.filterpopup,
          board: true,
          message: action.payload.message,
          code: 200,
          title: "success",
          bg: "primary",
        },
      };
    case actionType.EDIT_FILTER_HANDLER:
      const editallFilters = { ...state.filter };
      let editnewfilter = [...editallFilters.filter.user_filter];
      const newarray = editnewfilter.map((item) => {
        if (item.filter_id === action.payload.data.filter_id) {
          return {
            ...item,
            filter_value: JSON.stringify(action.payload.data.filter_value),
          };
        } else {
          return item;
        }
      });
      editallFilters["filter"]["user_filter"] = newarray;
      return {
        ...state,
        filter: editallFilters,
        filterpopup: {
          ...state.filterpopup,
          board: true,
          message: action.payload.message,
          code: action.payload.message,
          title: "success",
          bg: "primary",
        },
      };
    case actionType.TOGGLE_MENU:
      return {
        ...state,
        toggleMenu: !state.toggleMenu,
      };
    case actionType.RESET_BOARDS:
      return {
        ...state,
        child_board: [],
      };
    case actionType.ADD_REASON_ROW_UPDATE:
      const rowsdata = { ...state.rows, ...action.payload };
      return {
        ...state,
        rows: rowsdata,
      };
    case actionType.ADD_TODO_HANDLER:
      return {
        ...state,
        todoData: action.payload.attributes,
      };
    default:
      return state;
  }
};
